import { Box, Grid, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";

import { ApplicationWordArt, AuthenticationContainer, StyledLoginFormContainer } from "../../components";

export const NoLicenseTemplate = () => {
	return (
		<AuthenticationContainer>
			<StyledLoginFormContainer maxWidth="sm" data-testid="no-license">
				<Grid container direction="column" gap={6}>
					<Box sx={{ margin: "auto" }}>
						<ApplicationWordArt width={300} />
					</Box>

					<Grid container direction="column" gap={2}>
						<Typography color="white" fontWeight="bold">
							<FormattedMessage id="no-license.header" defaultMessage="No Valid License" />
						</Typography>
						<Typography color="white">
							<FormattedMessage
								id="no-license.subheader"
								defaultMessage="We're sorry, but your account does not have any valid license for this application. Please contact your Packsize representative."
							/>
						</Typography>
					</Grid>
				</Grid>
			</StyledLoginFormContainer>
		</AuthenticationContainer>
	);
};
